export enum Redundancie {
	Lineal = '226530000',

	Redundante = '226530001',

	Oneplusone = '226530002',
}
